<template>
	<div class="main-header" :variant="variant">
		<div class="main-header__col main-header__col--primary">
			<router-link to="/">
				<img
					class="main-header__logo"
					src="~@/assets/logo.png"
					alt="VUE Support Logo"
				/>
			</router-link>
			<h1 class="main-header__title">VUE Support</h1>
		</div>
		<div class="main-header__col main-header__col--secondary">
			<!-- START NOTIFICATIONS -->
			<!------- Temporarily Removed - Pending Implementation ------->
			<!-- <div class="main-header__notifications">
				<div class="main-header__action">
					<Button
						aria-label="Select to see the notifications"
						title="Select to see the notifications"
						className="btn--icon-only-circle"
						iconClassName="icon-notification"
						:btnClick="() => {}"
						:iconBeforeLabel="true"
					/>
				</div>
				<HeaderNotification />
			</div> -->
			<!-- END NOTIFICATIONS -->

			<!-- START DEVICE NAVIGATION MENU -->
			<div class="main-header__device-menu">
				<div class="main-header__action">
					<Button
						:id="`${uid}_button-show-menu`"
						:className="'btn--icon-only'"
						aria-label="select to show the menu"
						title="select to show the menu"
						:btnClick="showHamburguerMenuClick"
						:iconClassName="'icon-menu-header'"
						:iconBeforeLabel="true"
					/>
				</div>
				<DeviceMenu v-model="showHamburguerMenu" />
			</div>
			<!-- END DEVICE NAVIGATION MENU -->

			<div class="main-header__user" v-if="oidcUser">
				<span class="main-header__greeting"
					>Hello, {{ this.firstName }}!</span
				>
				<div class="main-header__action">
					<Button
						:id="`${uid}_button-signout`"
						:className="'btn--icon-only-circle'"
						:btnClick="signOut"
						aria-label="select to signout of your account"
						title="select to signout of your account"
						:iconClassName="'icon icon-logout'"
						:iconBeforeLabel="true"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DeviceMenu from '@/site-components/device-menu/device-menu';
import Button from '@/components/forms/button/button';
import getFirstName from '@/composables/get-first-name';

export default {
	name: 'HeaderBar',
	data() {
		return {
			showHamburguerMenu: false
		};
	},
	computed: {
		...mapGetters('oidcStore', ['oidcUser']),
		firstName() {
			return getFirstName(this.oidcUser);
		}
	},
	methods: {
		...mapActions('oidcStore', ['signOutOidc']),
		showHamburguerMenuClick() {
			this.showHamburguerMenu = true;
		},
		signOut() {
			localStorage.removeItem('oidcUser');
			this.signOutOidc();
		}
	},
	components: {
		Button,
		DeviceMenu
	},
	watch: {
		$route() {
			this.showHamburguerMenu = false;
		}
	}
};
</script>

<style lang="scss" scoped>
/**
	* Site Header
	* Can use SCSS variables = TRUE
 */

.main-header {
	display: flex;
	align-items: center;
	margin-left: $gutter-md; //matches footer
	margin-right: $gutter-md; //matches footer

	@include mq($from: lg) {
		@include contain(1200px);
	}

	&__logo {
		width: 40px;
	}

	&__title {
		font-size: $default-font-size;
		font-weight: $medium-font-weight;
		line-height: inherit;
		margin-left: $gutter-md;
	}
}

.main-header__col {
	display: flex;

	&--primary {
	}

	&--secondary {
		margin-left: auto;
	}
}

.main-header__action {
	font-size: $default-font-size * 1.5;
	.main-header__device-menu & {
		@include mq($from: lg) {
			display: none;
		}
	}
}

.main-header__notifications {
	position: relative;
}

.main-header__user {
	display: none;

	@include mq($from: lg) {
		display: inline-flex;
		align-items: center;
	}
}

.main-header__greeting {
	font-size: $default-font-size - 2;
	text-transform: capitalize;
}
</style>
